import { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { useAuth } from './AuthContext';

import api from '../services/api';


export const ParentContext = createContext({});

const ParentProvider = ({ children }) => {
  const history = useHistory();
  const [allChildren, setAllChildren] = useState([])
  const [selectedOne, setSelectedOne] = useState({});
  const [loading, setLoading] = useState(false)

  const { user } = useAuth();

  const token = localStorage.getItem('@Ocariot:token')

  useEffect(() => {
    setLoading(true);
    if(user) {
      if (user.type == 1) {
        api.get(`parent/${user._id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then((res) => {
          setAllChildren(res.data.data.children);
          setSelectedOne(res.data.data.children[0])
          setLoading(false);
        }).catch((err) => {
          console.log(err);
          setLoading(false);
        });
      } if 
      (user.type == 2) {
        
      }
    } else {
      setAllChildren([]);
      setSelectedOne({})
    }
  }, [user])

  const toggleChild = useCallback((child) => {
    setSelectedOne(child)
    localStorage.setItem('@Ocariot:child', JSON.stringify(child))
    history.push('childDashboard')
  }, [selectedOne])

  return (
    <ParentContext.Provider
      value={{ selectedOne, setSelectedOne, allChildren, setAllChildren, loading, toggleChild }}
    >
      {children}
    </ParentContext.Provider>
  );
}

const useListChildren = () => {
  const ctx = useContext(ParentContext);

  if (!ctx) {
    throw new Error('useListChildren must be used within an AuthProvider');
  }

  return ctx;
}

export { ParentProvider, useListChildren };